/**
 * EVIAL — Partner Program: заявка.
 *
 * Поля отдаёт приложение Shopify Forms — оно монтирует <shopify-forms-embed>
 * в свою секцию внизу страницы. Секция свёрнута до нулевой высоты, а сам
 * элемент при первом открытии переезжает внутрь нашей модалки: оболочка наша
 * (подложка, заголовок серифом, крестик, Escape), поля — приложения.
 *
 * Перенос кастомного элемента между контейнерами приложением не задокументирован,
 * поэтому после переезда проверяем, что поля на месте. Если нет — возвращаем
 * элемент на страницу и раскрываем секцию: заявку всё равно можно отправить.
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'ev-formwrap--open';
  var home = null; // куда вернуть элемент, если что-то пойдёт не так
  var moved = false;
  var fellBack = false;

  function embed() {
    return document.querySelector('shopify-forms-embed');
  }

  function section() {
    var e = embed();
    return e ? e.closest('.shopify-section') : null;
  }

  function dialog() {
    return document.getElementById('aff-apply-modal');
  }

  function fieldCount(e) {
    return e && e.shadowRoot ? e.shadowRoot.querySelectorAll('input, select, textarea').length : 0;
  }

  /* Форма не переехала или переехала сломанной — показываем её прямо на странице */
  function fallbackToPage() {
    fellBack = true;
    var e = embed();
    if (e && home && home.parent) {
      home.parent.insertBefore(e, home.next);
    }
    var sec = section();
    if (sec) {
      sec.classList.add(OPEN_CLASS);
      window.scrollTo({
        top: sec.getBoundingClientRect().top + window.pageYOffset - 90,
        behavior: 'smooth'
      });
    }
    var dlg = dialog();
    if (dlg && dlg.open) dlg.close();
    unlock();
  }

  function moveIntoModal() {
    if (moved || fellBack) return !fellBack;
    var e = embed();
    var slot = document.getElementById('aff-apply-slot');
    if (!e || !slot) return false;

    var before = fieldCount(e);
    home = { parent: e.parentNode, next: e.nextSibling };
    slot.appendChild(e);

    // Элемент мог не пережить переподключение — проверяем
    if (fieldCount(e) < before) {
      fallbackToPage();
      return false;
    }
    moved = true;
    return true;
  }

  function lock() {
    document.body.classList.add('aff-modal-open');
  }

  function unlock() {
    document.body.classList.remove('aff-modal-open');
  }

  var lastFocused = null;

  function open(trigger) {
    var dlg = dialog();
    if (!dlg || dlg.open) return;

    if (!moveIntoModal()) return; // ушли в запасной сценарий

    lastFocused = trigger || document.activeElement;
    if (typeof dlg.showModal === 'function') {
      dlg.showModal();
    } else {
      dlg.setAttribute('open', '');
    }
    lock();

    // Фокус в первое поле, но не на мобильном: иначе клавиатура закроет заголовок
    if (window.matchMedia('(min-width: 750px)').matches) {
      setTimeout(function () {
        var e = embed();
        var root = e && e.shadowRoot;
        var first = root && root.querySelector('input:not([type="hidden"]), select, textarea');
        if (first) {
          try {
            first.focus({ preventScroll: true });
          } catch (err) {
            /* не критично */
          }
        }
      }, 220);
    }
  }

  function close() {
    // Снимаем блокировку скролла безусловно: окно могло закрыться нативно
    unlock();
    var dlg = dialog();
    if (dlg && dlg.open) {
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    }
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    }
  }

  function init() {
    var dlg = dialog();
    var sec = section();
    if (!dlg || !sec || dlg.dataset.applyReady === 'true') return;
    dlg.dataset.applyReady = 'true';

    sec.classList.add('ev-formwrap');

    dlg.addEventListener('close', unlock);
    dlg.addEventListener('cancel', unlock);

    // Клик по подложке: у <dialog> подложка — это сам элемент
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) close();
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-apply-close]')) {
        e.preventDefault();
        close();
        return;
      }
      var trigger = e.target.closest('[data-apply-open]');
      if (trigger) {
        e.preventDefault();
        open(trigger);
      }
    });

    // Тема вешает свои обработчики клавиш, нативный Escape из-за них может не сработать
    document.addEventListener(
      'keydown',
      function (e) {
        if (dlg.open && (e.key === 'Escape' || e.key === 'Esc')) {
          e.preventDefault();
          close();
        }
      },
      true
    );

    if (window.location.hash === '#aff-apply') open(null);
  }

  // Скрипт приложения поднимается асинхронно — ждём появления элемента
  function waitForEmbed(tries) {
    if (embed()) {
      init();
      return;
    }
    if (tries > 40) return; // приложение не поднялось — кнопки просто не сработают
    setTimeout(function () {
      waitForEmbed(tries + 1);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForEmbed(0);
    });
  } else {
    waitForEmbed(0);
  }
})();
